// routes/ProtectedRoutes.js
import React from "react";
import ProtectedRoute from "../components/ProtectedRoute";

// Dashboard
import EventManagement from "../dashboard/EventManagement";
import SalesMonitoring from "../dashboard/SalesMonitoring";
import WebsiteAnalytics from "../dashboard/WebsiteAnalytics";
import FinanceMonitoring from "../dashboard/FinanceMonitoring";
import Cryptocurrency from "../dashboard/Cryptocurrency";
import HelpdeskService from "../dashboard/HelpdeskService";
import StorageManagement from "../dashboard/StorageManagement";
import ProductManagement from "../dashboard/ProductManagement";

// Apps
import Pricing from "../apps/Pricing";
import HistoriqueMessages from "../apps/HistoriqueMessages";
import HistoriquePaiement from "../apps/HistoriquePaiement";
import PendingModel from "../apps/PendingModel";
import Envoie from "../apps/Envoie";
import EnvoieMasse from "../apps/EnvoieMasse";
import ListeContacts from "../apps/ListeContacts";
import NumerosInvalid from "../apps/NumerosInvalid";
import Group from "../apps/Group";
import ImportContact from "../apps/ImportContact";
import ListeStops from "../apps/ListeStops";
import Entites from "../apps/Entites";
import Models from "../apps/Models";
import Recharge from "../apps/Recharge";
import SenderID from "../apps/SenderID";

import Documentation from "../apps/Documentation";
import enregistrerSeuil from "../apps/enregistrerSeuil";
import ClesApis from "../apps/ClesApis";
import Webhooks from "../apps/Webhooks";
import Aides from "../apps/Aides";
import MonCompte from "../apps/MonCompte";
import Entreprise from "../apps/Entreprise";
import Membres from "../apps/Membres";
import Facturation from "../apps/Facturation";
import AttenteConfirmationPaiement from "../apps/AttenteConfirmationPaiement";
import EnvoieMasseHome from "../apps/EnvoieMasseHome";
import ImportDetails from "../apps/ImportDetails";
import Tarifs from "../apps/Tarifs";
import regenererToken from "../apps/regenererToken";
import AlertesEnvoyees from "../apps/AlertesEnvoyees";
import AlertesSoldes from "../apps/AlertesSoldes";
import GsmPasserelles from "../apps/GsmPasserelles";
import GsmAffectations from "../apps/GsmAffectations";
import GsmHistoriqueSms from "../apps/GsmHistoriqueSms";

// Fonction utilitaire pour wrapper avec ProtectedRoute
const withProtection = (Component) => (
  <ProtectedRoute>
    <Component />
  </ProtectedRoute>
);

// 🔴 IMPORTANT: S'assurer que c'est un tableau
const protectedRoutes = [
  { path: "dashboard/finance", element: withProtection(FinanceMonitoring) },
  { path: "dashboard/events", element: withProtection(EventManagement) },
  { path: "dashboard/sales", element: withProtection(SalesMonitoring) },
  { path: "dashboard/analytics", element: withProtection(WebsiteAnalytics) },
  { path: "dashboard/crypto", element: withProtection(Cryptocurrency) },
  { path: "dashboard/helpdesk", element: withProtection(HelpdeskService) },
  { path: "dashboard/storage", element: withProtection(StorageManagement) },
  { path: "dashboard/product", element: withProtection(ProductManagement) },
  
  // Routes SMS
  { path: "apps/HistoriquePaiement", element: withProtection(HistoriquePaiement) },
  { path: "apps/Group", element: withProtection(Group) },
  { path: "apps/ImportContact", element: withProtection(ImportContact) },
  { path: "apps/Models", element: withProtection(Models) },
  { path: "apps/Recharge", element: withProtection(Recharge) },
  { path: "apps/SenderID", element: withProtection(SenderID) },

  { path: "apps/Documentation", element: withProtection(Documentation) },


  { path: "apps/ClesApis", element: withProtection(ClesApis) },
  { path: "apps/Webhooks", element: withProtection(Webhooks) },
  { path: "apps/Aides", element: withProtection(Aides) },
  { path: "apps/MonCompte", element: withProtection(MonCompte) },
  { path: "apps/Entreprise", element: withProtection(Entreprise) },
  { path: "apps/Membres", element: withProtection(Membres) },
  { path: "apps/Facturation", element: withProtection(Facturation) },
  { path: "apps/HistoriqueMessages", element: withProtection(HistoriqueMessages) },
  { path: "apps/PendingModel", element: withProtection(PendingModel) },
  { path: "apps/Envoie", element: withProtection(Envoie) },
  { path: "apps/EnvoieMasse", element: withProtection(EnvoieMasse) },
  { path: "apps/ListeContacts", element: withProtection(ListeContacts) },
  { path: "apps/NumerosInvalid", element: withProtection(NumerosInvalid) },
  { path: "apps/ListeStops", element: withProtection(ListeStops) },
  { path: "apps/enregistrerSeuil", element: withProtection(enregistrerSeuil) },
  { path: "apps/EnvoieMasseHome", element: withProtection(EnvoieMasseHome) },
  { path: "apps/Tarifs", element: withProtection(Tarifs) },
  { path: "apps/AttenteConfirmationPaiement", element: withProtection(AttenteConfirmationPaiement) },
  { path: "apps/regenererToken", element: withProtection(regenererToken) },
  { path: "apps/Entites", element: withProtection(Entites) },
  { path: "apps/AlertesEnvoyees", element: withProtection(AlertesEnvoyees) },
  { path: "apps/AlertesSoldes", element: withProtection(AlertesSoldes) },
  { path: "apps/Pricing", element: withProtection(Pricing) },
  { path: "apps/GsmPasserelles", element: withProtection(GsmPasserelles) },
  { path: "apps/GsmAffectations", element: withProtection(GsmAffectations) },
  { path: "apps/GsmHistoriqueSms", element: withProtection(GsmHistoriqueSms) },
];

// 🔴 Vérifier que c'est bien un tableau avant d'exporter
console.log('🔍 protectedRoutes est un tableau:', Array.isArray(protectedRoutes));
console.log('📊 Nombre de routes:', protectedRoutes.length);

export default protectedRoutes;